import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { RewardsWalletService } from '@fgb/core';
import { filter, firstValueFrom, pairwise } from 'rxjs';

@Component({
  selector: 'fgb-lotto-wallet-details-page',
  templateUrl: './lotto-wallet-details-page.component.html',
  styleUrls: ['./lotto-wallet-details-page.component.scss']
})
export class LottoWalletDetailsPageComponent implements OnInit {
  id: number;
  screenSize = ScreenType;
  mobileTitle: string = 'wallet.page.title';

  constructor(
    private route: ActivatedRoute,
    private rewardsWalletService: RewardsWalletService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }

  ngAfterViewInit(): void {
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        this._getMobileTitle(events[0].urlAfterRedirects);
      });
  }

  private _getMobileTitle(prevUrl: string): void {
    const claimedRoute = ['claimed'];
    if (claimedRoute.some((title) => prevUrl.includes(title))) {
      this.mobileTitle = 'wallet.page.claimed.rewards';
    }
    this.cd.detectChanges();
  }
}
